import React, { useState } from 'react';

const Beneficiary = () => {
  const [sdate, setSdate] = useState('');
  const [edate, setEdate] = useState('');
  const [mobile, setMobile] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5; // Number of items per page

  const transactionData = [
    { srNo: 1, name: 'Mayank Pal', mobile: '7786042003', bankAccount: '55550123839431', bankName: 'Federal Bank', statusbank: 'Success', bankreferanceid: '0AAA9957ACBC6A4517AB32AA612C5F', URN: 'SR206442275', amount: 150, IMPSNo: '433800651930', paystatus: 'Success', transactionDate: '12/3/2024 12:01:55 AM', transactionNo: 'TXN507748606' },
    { srNo: 2, name: 'Mayank Pal', mobile: '7786042003', bankAccount: '55550123839431', bankName: 'Federal Bank', statusbank: 'Success', bankreferanceid: '40C16C16AF7BEA4FBCA9C8FA690B3E', URN: 'SR206442275', amount: 20, IMPSNo: '433721408786', paystatus: 'Success', transactionDate: '12/2/2024 9:22:30 PM', transactionNo: 'TXN270430479' },
    { srNo: 3, name: 'Dileep Kumar', mobile: '7786042003', bankAccount: '6569224192', bankName: 'Indian Bank', statusbank: 'Success', bankreferanceid: '960A63EBAC921A44D3AB9DFA6FE4D2', URN: 'SR206442275', amount: 40, IMPSNo: '433415101686', paystatus: 'Success', transactionDate: '11/29/2024 3:34:48 PM', transactionNo: 'TXN271461173' },
    { srNo: 4, name: 'John Doe', mobile: '1234567890', bankAccount: '12345678901234', bankName: 'ABC Bank', statusbank: 'Pending', bankreferanceid: 'B1B2B3B4', URN: 'SR206442276', amount: 100, IMPSNo: '433800651931', paystatus: 'Pending', transactionDate: '12/1/2024 8:15:30 PM', transactionNo: 'TXN507748607' },
    { srNo: 5, name: 'Jane Smith', mobile: '9876543210', bankAccount: '98765432109876', bankName: 'XYZ Bank', statusbank: 'Failed', bankreferanceid: 'C1C2C3C4', URN: 'SR206442277', amount: 50, IMPSNo: '433800651932', paystatus: 'Failed', transactionDate: '11/30/2024 6:12:10 PM', transactionNo: 'TXN507748608' },
    { srNo: 6, name: 'Emily Davis', mobile: '5551234567', bankAccount: '11223344556677', bankName: 'DEF Bank', statusbank: 'Success', bankreferanceid: 'D1D2D3D4', URN: 'SR206442278', amount: 250, IMPSNo: '433800651933', paystatus: 'Success', transactionDate: '11/28/2024 5:30:00 PM', transactionNo: 'TXN507748609' },
    { srNo: 7, name: 'Chris Brown', mobile: '6677889900', bankAccount: '55667788990011', bankName: 'GHI Bank', statusbank: 'Success', bankreferanceid: 'E1E2E3E4', URN: 'SR206442279', amount: 75, IMPSNo: '433800651934', paystatus: 'Success', transactionDate: '11/27/2024 4:00:00 PM', transactionNo: 'TXN507748610' },
    { srNo: 8, name: 'Olivia Green', mobile: '1234567890', bankAccount: '78912345678901', bankName: 'JKL Bank', statusbank: 'Failed', bankreferanceid: 'F1F2F3F4', URN: 'SR206442280', amount: 200, IMPSNo: '433800651935', paystatus: 'Failed', transactionDate: '11/26/2024 2:40:00 PM', transactionNo: 'TXN507748611' },
    { srNo: 9, name: 'Liam Scott', mobile: '5551231234', bankAccount: '11223344557788', bankName: 'MNO Bank', statusbank: 'Success', bankreferanceid: 'G1G2G3G4', URN: 'SR206442281', amount: 120, IMPSNo: '433800651936', paystatus: 'Success', transactionDate: '11/25/2024 1:10:30 PM', transactionNo: 'TXN507748612' },
    { srNo: 10, name: 'Ava Williams', mobile: '7778889990', bankAccount: '99887766554433', bankName: 'PQR Bank', statusbank: 'Success', bankreferanceid: 'H1H2H3H4', URN: 'SR206442282', amount: 180, IMPSNo: '433800651937', paystatus: 'Success', transactionDate: '11/24/2024 12:30:10 PM', transactionNo: 'TXN507748613' },
  ];

  // Calculate the index range of transactions to display
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentTransactions = transactionData.slice(indexOfFirstItem, indexOfLastItem);

  // Handle page change
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Sdate:', sdate, 'Edate:', edate, 'Mobile:', mobile);
  };

  const containerStyle = {
    marginTop: '50px',
    padding: '20px',
    backgroundColor: '#f4f4f9',
    borderRadius: '8px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    maxWidth: '1200px',
    marginLeft: 'auto',
    marginRight: 'auto',
  };

  const formGroupStyle = {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '15px',
    flex: 1,
  };

  const labelStyle = {
    fontWeight: 'bold',
    marginBottom: '5px',
  };

  const inputStyle = {
    padding: '8px',
    fontSize: '14px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    width: '100%',
  };

  const buttonStyle = {
    padding: '10px 20px',
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '16px',
    marginTop: '20px',
  };

  const tableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '30px',
    tableLayout: 'auto',
  };

  const thTdStyle = {
    border: '1px solid #ddd',
    padding: '8px',
    textAlign: 'left',
  };

  const thStyle = {
    backgroundColor: '#f1f1f1',
    fontWeight: 'bold',
  };

  const paginationStyle = {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '20px',
  };

  const pageButtonStyle = {
    padding: '8px 16px',
    margin: '0 5px',
    border: '1px solid #ccc',
    backgroundColor: '#f1f1f1',
    cursor: 'pointer',
  };

  return (
    <div style={containerStyle}>
      <h4 style={{ textAlign: 'left', marginBottom: '20px' }}>Beneficiary Transaction</h4>

      <form onSubmit={handleSubmit}>
        <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
          <div style={{ ...formGroupStyle, maxWidth: '30%' }}>
            <label style={labelStyle}>Sdate</label>
            <input type="date" style={inputStyle} value={sdate} onChange={(e) => setSdate(e.target.value)} />
          </div>

          <div style={{ ...formGroupStyle, maxWidth: '30%' }}>
            <label style={labelStyle}>Edate</label>
            <input type="date" style={inputStyle} value={edate} onChange={(e) => setEdate(e.target.value)} />
          </div>

          <div style={{ ...formGroupStyle, maxWidth: '30%' }}>
            <label style={labelStyle}>Mobile No.</label>
            <input type="text" style={inputStyle} value={mobile} onChange={(e) => setMobile(e.target.value)} placeholder="Enter Mobile" />
          </div>

          <button type="submit" style={buttonStyle}>
            Submit
          </button>
        </div>
      </form>

      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={{ ...thTdStyle, ...thStyle }}>Sr No.</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Name</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Mobile</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Bank Account</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Bank Name</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Status From Bank</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Bank Reference Id</th>
            <th style={{ ...thTdStyle, ...thStyle }}>URN</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Amount</th>
            <th style={{ ...thTdStyle, ...thStyle }}>IMPS No</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Pay Status</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Transaction Date</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Transaction No</th>
          </tr>
        </thead>
        <tbody>
          {currentTransactions.map((transaction) => (
            <tr key={transaction.srNo}>
              <td style={thTdStyle}>{transaction.srNo}</td>
              <td style={thTdStyle}>{transaction.name}</td>
              <td style={thTdStyle}>{transaction.mobile}</td>
              <td style={thTdStyle}>{transaction.bankAccount}</td>
              <td style={thTdStyle}>{transaction.bankName}</td>
              <td style={thTdStyle}>{transaction.statusbank}</td>
              <td style={thTdStyle}>{transaction.bankreferanceid}</td>
              <td style={thTdStyle}>{transaction.URN}</td>
              <td style={thTdStyle}>{transaction.amount}</td>
              <td style={thTdStyle}>{transaction.IMPSNo}</td>
              <td style={thTdStyle}>{transaction.paystatus}</td>
              <td style={thTdStyle}>{transaction.transactionDate}</td>
              <td style={thTdStyle}>{transaction.transactionNo}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Pagination Controls */}
      <div style={paginationStyle}>
        <button
          style={pageButtonStyle}
          onClick={() => setCurrentPage(currentPage - 1)}
          disabled={currentPage === 1}
        >
          Previous
        </button>
        {[...Array(Math.ceil(transactionData.length / itemsPerPage))].map((_, index) => (
          <button
            key={index}
            style={pageButtonStyle}
            onClick={() => paginate(index + 1)}
            className={currentPage === index + 1 ? 'active' : ''}
          >
            {index + 1}
          </button>
        ))}
        <button
          style={pageButtonStyle}
          onClick={() => setCurrentPage(currentPage + 1)}
          disabled={currentPage === Math.ceil(transactionData.length / itemsPerPage)}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Beneficiary;
